export default __webpack_public_path__ + "static/media/home_es.2e3fa194.md";